import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/_guards/auth.guard';
import { RoleGuard } from '../auth/_guards/role.guard';

const routes: Routes = [
	{
		path: '',
		component: ThemeComponent,
		canActivate: [AuthGuard],
		children: [
			// HOME
			{
				path: 'index',
				loadChildren: () => import('./pages/admin/index/index.module').then(m => m.IndexModule)
			},
			// ROLE GROUP
			{
				path: 'role-group',
				loadChildren: () => import('./pages/admin/role-group/find/role-group-find.module').then(m => m.RoleGroupFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.permissions.manage'
				}
			},
			{
				path: 'role-group/create',
				loadChildren: () => import('./pages/admin/role-group/create/role-group-create.module').then(m => m.RoleGroupCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.permissions.manage'
				}
			},
			{
				path: 'role-group/:id',
				loadChildren: () => import('./pages/admin/role-group/read/role-group-read.module').then(m => m.RoleGroupReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.permissions.manage'
				}
			},
			{
				path: 'role-group/:id/update',
				loadChildren: () => import('./pages/admin/role-group/update/role-group-update.module').then(m => m.RoleGroupUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.permissions.manage'
				}
			},
			// Organization
			{
				path: 'organization',
				loadChildren: () => import('./pages/admin/organization/find/organization-find.module').then(m => m.OrganizationFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'organization/create',
				loadChildren: () => import('./pages/admin/organization/create/organization-create.module').then(m => m.OrganizationCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'organization/:id',
				loadChildren: () => import('./pages/admin/organization/read/organization-read.module').then(m => m.OrganizationReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'organization/:id/update',
				loadChildren: () => import('./pages/admin/organization/update/organization-update.module').then(m => m.OrganizationUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			// User
			{
				path: 'user',
				loadChildren: () => import('./pages/admin/user/find/user-find.module').then(m => m.UserFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.users.manage'
				}
			},
			{
				path: 'user/create',
				loadChildren: () => import('./pages/admin/user/create/user-create.module').then(m => m.UserCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.users.manage'
				}
			},
			{
				path: 'user/:id',
				loadChildren: () => import('./pages/admin/user/read/user-read.module').then(m => m.UserReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.users.manage'
				}
			},
			{
				path: 'user/:id/update',
				loadChildren: () => import('./pages/admin/user/update/user-update.module').then(m => m.UserUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.users.manage'
				}
			},
			// campuses
			{
				path: 'campus',
				loadChildren: () => import('./pages/admin/campus/find/campus-find.module').then(m => m.CampusFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'campus/create',
				loadChildren: () => import('./pages/admin/campus/create/campus-create.module').then(m => m.CampusCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'campus/:id',
				loadChildren: () => import('./pages/admin/campus/read/campus-read-modules').then(m => m.CampusReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'campus/:id/update',
				loadChildren: () => import('./pages/admin/campus/update/campus-update-module').then(m => m.CampusUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},

			// BUILDING
			{
				path: 'building',
				loadChildren: () => import('./pages/admin/building/find/building-find.module').then(m => m.BuildingFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'building/create',
				loadChildren: () => import('./pages/admin/building/create/building-create.module').then(m => m.BuildingCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'building/:id',
				loadChildren: () => import('./pages/admin/building/read/building-read.module').then(m => m.BuildingReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'building/:id/update',
				loadChildren: () => import('./pages/admin/building/update/building-update.module').then(m => m.BuildingUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			// FLOOR
			{
				path: 'floor',
				loadChildren: () => import('./pages/admin/floor/find/floor-find.module').then(m => m.FloorFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'floor/create',
				loadChildren: () => import('./pages/admin/floor/create/floor-create.module').then(m => m.FloorCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'floor/:id',
				loadChildren: () => import('./pages/admin/floor/read/floor-read.module').then(m => m.FloorReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'floor/:id/update',
				loadChildren: () => import('./pages/admin/floor/update/floor-update.module').then(m => m.FloorUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			// ROOM
			{
				path: 'room',
				loadChildren: () => import('./pages/admin/room/find/room-find.module').then(m => m.RoomFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'room/create',
				loadChildren: () => import('./pages/admin/room/create/room-create.module').then(m => m.RoomCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'create-room-with-ai',
				loadChildren: () => import('./pages/admin/room/create-ai/room-create-ai.module').then(m => m.RoomCreateAiModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'room/:id',
				loadChildren: () => import('./pages/admin/room/read/room-read.module').then(m => m.RoomReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'room/:id/update',
				loadChildren: () => import('./pages/admin/room/update/room-update.module').then(m => m.RoomUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				},
			},
			// REPORT
			{
				path: 'report/incident',
				loadChildren: () => import('./pages/admin/report/incident/report-incidents.module').then(m => m.ReportIncidentsModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.analytics'
				}
			},
			{
				path: 'report/incident/:id',
				loadChildren: () => import('./pages/admin/report/incident/info/report-incident-info.module').then(m => m.ReportIncidentInfoModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.analytics'
				}
			},
			// MESSAGE TEMPLATES
			{
				path: 'message-template',
				loadChildren: () => import('./pages/admin/message-template/find/message-template-find.module').then(m => m.MessageTemplateFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'message-template/create',
				loadChildren: () => import('./pages/admin/message-template/create/message-template-create.module').then(m => m.MessageTemplateCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'message-template/:id',
				loadChildren: () => import('./pages/admin/message-template/read/message-template-read.module').then(m => m.MessageTemplateReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'message-template/:id/update',
				loadChildren: () => import('./pages/admin/message-template/update/message-template-update.module').then(m => m.MessageTemplateUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			// BEACON REGION
			{
				path: 'beacon-region',
				loadChildren: () => import('./pages/admin/beacon-region/find/beacon-region-find.module').then(m => m.BeaconRegionFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'beacon-region/create',
				loadChildren: () => import('./pages/admin/beacon-region/create/beacon-region-create.module').then(m => m.BeaconRegionCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'beacon-region/:id',
				loadChildren: () => import('./pages/admin/beacon-region/read/beacon-region-read.module').then(m => m.BeaconRegionReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'beacon-region/:id/update',
				loadChildren: () => import('./pages/admin/beacon-region/update/beacon-region-update.module').then(m => m.BeaconRegionUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			// MERIDIAN LOCATION
			{
				path: 'meridian-location',
				loadChildren: () => import('./pages/admin/meridian-location/find/meridian-location-find.module').then(m => m.MeridianLocationFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'meridian-location/create',
				loadChildren: () => import('./pages/admin/meridian-location/create/meridian-location-create.module').then(m => m.MeridianLocationCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'meridian-location/:id',
				loadChildren: () => import('./pages/admin/meridian-location/read/meridian-location-read.module').then(m => m.MeridianLocationReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'meridian-location/:id/update',
				loadChildren: () => import('./pages/admin/meridian-location/update/meridian-location-update.module').then(m => m.MeridianLocationUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			// MERIDIAN MAP
			{
				path: 'meridian-map',
				loadChildren: () => import('./pages/admin/meridian-map/find/meridian-map-find.module').then(m => m.MeridianMapFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'meridian-map/create',
				loadChildren: () => import('./pages/admin/meridian-map/create/meridian-map-create.module').then(m => m.MeridianMapCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'meridian-map/:id',
				loadChildren: () => import('./pages/admin/meridian-map/read/meridian-map-read.module').then(m => m.MeridianMapReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			{
				path: 'meridian-map/:id/update',
				loadChildren: () => import('./pages/admin/meridian-map/update/meridian-map-update.module').then(m => m.MeridianMapUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.perimeters.manage'
				}
			},
			// INCIDENT CATEGORY
			{
				path: 'incident-category',
				loadChildren: () => import('./pages/admin/incident-category/find/incident-category-find.module').then(m => m.IncidentCategoryFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			{
				path: 'incident-category/create',
				loadChildren: () => import('./pages/admin/incident-category/create/incident-category-create.module').then(m => m.IncidentCategoryCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			{
				path: 'incident-category/clone',
				loadChildren: () => import('./pages/admin/incident-category/clone/incident-category-clone.module').then(m => m.IncidentCategoryCloneModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			{
				path: 'incident-category/:id',
				loadChildren: () => import('./pages/admin/incident-category/read/incident-category-read.module').then(m => m.IncidentCategoryReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			{
				path: 'incident-category/:id/update',
				loadChildren: () => import('./pages/admin/incident-category/update/incident-category-update.module').then(m => m.IncidentCategoryUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			/*
			// INCIDENT CATEGORY ALERT VENDOR
			{
				path: 'incident-category-alert-vendor',
				loadChildren: './pages/admin/incident-category-alert-vendor/find/incident-category-alert-vendor-find.module#IncidentCategoryAlertVendorFindModule'
			},
			{
				path: 'incident-category-alert-vendor/create',
				loadChildren: './pages/admin/incident-category-alert-vendor/create/incident-category-alert-vendor-create.module#IncidentCategoryAlertVendorCreateModule'
			},
			{
				path: 'incident-category-alert-vendor/:id',
				loadChildren: './pages/admin/incident-category-alert-vendor/read/incident-category-alert-vendor-read.module#IncidentCategoryAlertVendorReadModule'
			},
			{
				path: 'incident-category-alert-vendor/:id/update',
				loadChildren: './pages/admin/incident-category-alert-vendor/update/incident-category-alert-vendor-update.module#IncidentCategoryAlertVendorUpdateModule'
			},
			*/
			// SOP
			{
				path: 'sop',
				loadChildren: () => import('./pages/admin/sop/find/sop-find.module').then(m => m.SopFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			{
				path: 'sop/create',
				loadChildren: () => import('./pages/admin/sop/create/sop-create.module').then(m => m.SopCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			{
				path: 'sop/:id',
				loadChildren: () => import('./pages/admin/sop/read/sop-read.module').then(m => m.SopReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			{
				path: 'sop/:id/update',
				loadChildren: () => import('./pages/admin/sop/update/sop-update.module').then(m => m.SopUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			{
				path: 'sop/:id/copy',
				loadChildren: () => import('./pages/admin/sop/copy/sop-copy.module').then(m => m.SopCopyModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.sops.manage'
				}
			},
			// ORGANIZATION GROUPS
			{
				path: 'organization-group',
				loadChildren: () => import('./pages/admin/organization-group/find/organization-group-find.module').then(m => m.OrganizationGroupFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'organization-group/create',
				loadChildren: () => import('./pages/admin/organization-group/create/organization-group-create.module').then(m => m.OrganizationGroupCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'organization-group/:id',
				loadChildren: () => import('./pages/admin/organization-group/read/organization-group-read.module').then(m => m.OrganizationGroupReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			{
				path: 'organization-group/:id/update',
				loadChildren: () => import('./pages/admin/organization-group/update/organization-group-update.module').then(m => m.OrganizationGroupUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.organizations.manage'
				}
			},
			// SDK
			{
				path: 'sdk',
				loadChildren: () => import('./pages/admin/sdk/find/sdk-find.module').then(m => m.SdkFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'sdk/create',
				loadChildren: () => import('./pages/admin/sdk/create/sdk-create.module').then(m => m.SdkCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'sdk/:id',
				loadChildren: () => import('./pages/admin/sdk/read/sdk-read.module').then(m => m.SdkReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'sdk/:id/update',
				loadChildren: () => import('./pages/admin/sdk/update/sdk-update.module').then(m => m.SdkUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			// APPLICATION
			{
				path: 'application',
				loadChildren: () => import('./pages/admin/application/find/application-find.module').then(m => m.ApplicationFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'application/create',
				loadChildren: () => import('./pages/admin/application/create/application-create.module').then(m => m.ApplicationCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'application/:id',
				loadChildren: () => import('./pages/admin/application/read/application-read.module').then(m => m.ApplicationReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'application/:id/update',
				loadChildren: () => import('./pages/admin/application/update/application-update.module').then(m => m.ApplicationUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			// INTEGRATION
			{
				path: 'integration',
				loadChildren: () => import('./pages/admin/integration/find/integration-find.module').then(m => m.IntegrationFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'integration/create',
				loadChildren: () => import('./pages/admin/integration/create/integration-create.module').then(m => m.IntegrationCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'integration/:id',
				loadChildren: () => import('./pages/admin/integration/read/integration-read.module').then(m => m.IntegrationReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'integration/:id/update',
				loadChildren: () => import('./pages/admin/integration/update/integration-update.module').then(m => m.IntegrationUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'integration/:id/copy',
				loadChildren: () => import('./pages/admin/integration/copy/integration-copy.module').then(m => m.IntegrationCopyModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			// RULE
			{
				path: 'rule',
				loadChildren: () => import('./pages/admin/rule/find/rule-find.module').then(m => m.RuleFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'rule/create',
				loadChildren: () => import('./pages/admin/rule/create/rule-create.module').then(m => m.RuleCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'rule/:id',
				loadChildren: () => import('./pages/admin/rule/read/rule-read.module').then(m => m.RuleReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'rule/:id/update',
				loadChildren: () => import('./pages/admin/rule/update/rule-update.module').then(m => m.RuleUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'rule/:id/copy',
				loadChildren: () => import('./pages/admin/rule/copy/rule-copy.module').then(m => m.RuleCopyModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			// ACTION
			{
				path: 'action',
				loadChildren: () => import('./pages/admin/action/find/action-find.module').then(m => m.ActionFindModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'action/create',
				loadChildren: () => import('./pages/admin/action/create/action-create.module').then(m => m.ActionCreateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'action/:id',
				loadChildren: () => import('./pages/admin/action/read/action-read.module').then(m => m.ActionReadModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'action/:id/update',
				loadChildren: () => import('./pages/admin/action/update/action-update.module').then(m => m.ActionUpdateModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			},
			{
				path: 'action/:id/copy',
				loadChildren: () => import('./pages/admin/action/copy/action-copy.module').then(m => m.ActionCopyModule),
				canActivate: [RoleGuard],
				data: {
					role: 'arcadmin.app.admin'
				}
			}
		]
	},
	{
		path: '**',
		'redirectTo': '404',
		'pathMatch': 'full'
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ThemeRoutingModule { }